import { render, staticRenderFns } from "./startupDatabase.vue?vue&type=template&id=1a687f0c&scoped=true&"
import script from "./startupDatabase.vue?vue&type=script&lang=js&"
export * from "./startupDatabase.vue?vue&type=script&lang=js&"
import style0 from "./startupDatabase.vue?vue&type=style&index=0&id=1a687f0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a687f0c",
  null
  
)

export default component.exports